export class UserGroup {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {string} */
    createdAt = '';

    /** @type {string} */
    updatedAt = '';

    /**
     * @param {Object} obj
     * @returns {UserGroup}
     */
    static fromArray(obj) {
        return Object.assign(new this, obj || {});
    }
}